import { render, staticRenderFns } from "./LocalAgentCard.vue?vue&type=template&id=dc9bf86c&scoped=true"
import script from "./LocalAgentCard.vue?vue&type=script&lang=js"
export * from "./LocalAgentCard.vue?vue&type=script&lang=js"
import style0 from "./LocalAgentCard.vue?vue&type=style&index=0&id=dc9bf86c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9bf86c",
  null
  
)

export default component.exports